export default __webpack_public_path__ + "static/media/covid19.9e5d4fc7.png";